import { I18nData, InboxDTO, getSimpleIdentifierFromString, UserDTO, TaskDTO } from './../../api/plyca-dtos';
import { InboxEditionComponent } from './inbox.edition.component';
import { Component, AfterContentInit, OnDestroy, ElementRef, ViewChild, OnInit } from '@angular/core';
import { PlycaDataService } from '../../../services/plyca.service';
import { UIService } from '../../ui.service';
import { TranslateService } from '@ngx-translate/core';
import { HelpService, HelpType } from '../../components/common/help/help.service';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import { catchError, finalize, tap } from 'rxjs/operators';
import { Configuration } from '../../conf/app.constants';
import { WaitLoadingService } from '../../components/common/waitLoading/wait-loading.service';
import { BaseComponent } from '../../components/common/baseComponent/base.component';
import { FormConfig } from '../../components/forms/form.objects';
import { formPlycaComponent } from '../../components/forms/formPlyca.component';
import { Observable, of } from 'rxjs';
import { DatePipe } from '@angular/common';
import { UserService } from '../../user.service';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';
import { DialogService, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { ConfirmationService } from 'primeng-lts/api';
import { PropertyService } from '../../properties/property.service';
import { ActivatedRoute } from '@angular/router';
import { PaginationDTO } from '../../api/PaginationModel';
import { tasksListComponent } from '../../tasks/tasksList.component';

@Component({
  selector: 'inboxPanel',
  templateUrl: 'inboxPanel.template.html',
  providers: [DatePipe, DialogService]
})
export class InboxPanelComponent extends BaseComponent implements AfterContentInit, OnDestroy, OnInit {
  loaded = false;
  elements: InboxDTO[] = [];

  @ViewChild('formPlycaRef') formPlycaRef1: formPlycaComponent;
  formConfig1: FormConfig;
  public filterModel: any;

  userid: string;





  constructor(
    public plycaService: PlycaDataService,
    public configuration: Configuration,
    public helpService: HelpService,
    public uiService: UIService,
    public userService: UserService,
    public waitService: WaitLoadingService,
    private headerActionsService: HeaderActionsService,
    private elem: ElementRef,
    public dialogService: DialogService,
    private confirmationService: ConfirmationService,
    private plycaErrorHandler: PlycaErrorHandler,
    private propertyService: PropertyService,
    public translate: TranslateService,
    private _configuration: Configuration,
    protected route: ActivatedRoute
  ) {
    super();
    this.subscribe(this.helpService.showContextHelpObservable(HelpType.INBOXS));

    this.subscribe(this.route.queryParams, params => {

      this.userid = params['userid'];
    });
    this.dtoToModel();



  }
  ngOnInit(): void {


  }



  dtoToModel() {

    this.filterModel = {};
    this.filterModel.organizationalUnitId = this.userService.sessionInfo.user.organizationalUnit;
    if (this.userid) {
      this.filterModel.user = new UserDTO();
      this.filterModel.user.identifier = this.userid;
    }
    this.subscribe(this.createFormConfig1(),
      (form1: FormConfig) => {
        this.formConfig1 = form1;
      });
  }



  private createFormConfig1(): Observable<FormConfig> {
    return of(new FormConfig(undefined,
      'admin/inboxFilterISettings.json',
      this.filterModel
    ));
  }

  ngAfterContentInit(): void {


    this.headerActionsService.setTaskDescription(this.elem, 'ControlPanel.inboxs.title', 'fas fa-inbox', this.isLoaded.bind(this));
    this.subscribe(
      this.headerActionsService.addAction(
        'General.add',
        'fas fa-plus',
        'btn-primary',
        true
      ), success => {
        this.openInbox('new');
      });
    /*  this.subscribe(
        this.headerActionsService.addAction(
          'General.reset.filters',
          'fas fa-undo',
          'btn-secondary',
          true
        ), success => {
          this.clearFilter();
        });

      this.subscribe(
        this.headerActionsService.addAction(
          'General.search.text',
          'fas fa-search',
          'btn-primary',
          true
        ), success => {
          this.loadData();
        });*/
    this.headerActionsService.addDivider();
    this.subscribe(this.headerActionsService.addAction(
      'General.back',
      'fas fa-chevron-left',
      'btn-outline-secondary',
      true
    ), success => {
      this.uiService.routeBack();
    });

    this.loadData();
  }

  ngOnDestroy() {
    this.headerActionsService.clearActions();
    super.ngOnDestroy();
  }

  public isLoaded(): boolean {
    return this.loaded;
  }



  public clearFilter(): void {

    this.filterModel.identifier = undefined;
    this.filterModel.name = undefined;
    this.filterModel.description = undefined;
    this.filterModel.organizationalUnitId = this.userService.sessionInfo.user.organizationalUnit;
    this.filterModel.profiles = undefined;
  }



  loadData() {
    this.waitService.startWaiting();
    this.loaded = false;
    let filters = this.getParams();

    if (JSON.stringify(filters) === '{}') {

      this.uiService.showMessage(
        new I18nData('ControlPanel.inboxs.msg.filters'),
        new I18nData('General.info')
      );
      this.loaded = true;
      this.waitService.cancelWaiting();
    } else {



      this.subscribe(
        this.plycaService.query<InboxDTO>(
          this.configuration.INBOX_SERVICE_URL, filters
        ).pipe(
          finalize(() => {
            this.loaded = true;
            this.waitService.cancelWaiting();
          })
        ),
        results => {
          if (results && results.content) {
            this.elements = results.content;
          } else {
            this.elements = [];
          }
          this.loaded = true;
        },
        error => {
          this.waitService.cancelWaiting();
          this.plycaErrorHandler.showServerError(error)
        });
    }

  }





  openInbox(identifier: any, readonly = false) {


    let estilo = 'formEdition';
    let titulo = '';
    // this.translate.instant('Substitution.title');
    if (readonly) {
      estilo = 'viewStyle';

    }

    let config: DynamicDialogConfig = {
      header: titulo,
      width: '70%',
      styleClass: estilo
    };

    config['id'] = identifier;
    config['readonly'] = readonly;


    const ref = this.dialogService.open(
      InboxEditionComponent,
      config
    );

    this.subscribe(ref.onClose,
      result => {
        this.loadData();
      });
  }


  getParams() {

    let params: any = {};

    if (this.formConfig1.model) {



      if (this.formConfig1.model.identifier) {
        params.identifier = this.formConfig1.model.identifier;
      }
      if (this.formConfig1.model.description) {
        params.description = this.formConfig1.model.description;
      }
      if (this.formConfig1.model.name) {
        params.name = this.formConfig1.model.name;
      }
      if (this.formConfig1.model.organizationalUnitId && this.formConfig1.model.organizationalUnitId.identifier) {
        params.organizationalUnitId = this.formConfig1.model.organizationalUnitId.identifier;
      }
      if (this.formConfig1.model.profiles) {
        params.profiles = [];
        this.formConfig1.model.profiles.forEach(element => {

          params.profiles.push(getSimpleIdentifierFromString(element.identifier))
        }
        )
      }



    }


    return params;

  }



  inboxTasks(inbox: InboxDTO) {

    let title = 'ControlPanel.inboxs.actions.userTasks';
    let config: DynamicDialogConfig = {
      header: this.translate.instant(title) + ' ' + inbox.name + ' [' + inbox.identifier + ']',
      width: '60%',
      styleClass: 'viewStyle'

    };


    let params: { [param: string]: any } = {};
    params['page'] = 0;
    params['size'] = 9999;
    params['expand'] = 'expansionSet:client_tasks';


    params['selectedInboxId'] = inbox.identifier;
    /* this.isModalWindow = true;
     this.windowHash = generateRandomIdentifier();
     this.waitService.startWaiting();*/
    let t;
    this.waitService.startWaiting();
    this.subscribe(
      this.plycaService.query(
        this._configuration.TAKS_SERVICE_URL, params
      ).pipe(
        tap((param: PaginationDTO<TaskDTO>) => {
          t = param ? param.content : [];
          config['inboxId'] = inbox.identifier;
          config['list'] = t;

          const dialog = this.dialogService.open(tasksListComponent, config);
          dialog.onClose.subscribe(person => {



          });

        }),
        catchError(
          (err) => {

            this.plycaErrorHandler.showServerError(err);
            this.waitService.cancelWaiting();

            return of(true);
          }),
        finalize(() => {

        })
      )
    );



  }

}
